module.exports = __webpack_public_path__ + "./data/zooData.2.81.0.json";